module.exports = __webpack_public_path__ + "img/call.71872e39.svg";